import { btPagesColumn } from "../resource/bt-pages-column";
import { NeededColumn } from "./needed-column";

export const btPageNeededColumn = new NeededColumn(
  "09ec65d5-ead0-49f1-aebc-60f41cc177e0",
  btPagesColumn,
  "Black Page Needed"
)
